/* index.tsx generated by @compiled/babel-plugin v0.37.1 */
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-unsafe-style-overrides */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._nd5lbc26%7Bgrid-area%3Aactions%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wpz1h6o%7Balign-self%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wpzv2br%7Balign-self%3Astart%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c13yo%7Bdisplay%3Avar(--elem-after-display)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1c3z%7Bdisplay%3Avar(--actions-on-hover-display)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._zulp1b66%7Bgap%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._nd5l16dh%7Bgrid-area%3Aelem-after%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18ukglyw%3Anot(%3Ahas(button%2Ca))%7Bpointer-events%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._12l2utpp%7Bmargin-inline-end%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bozgpxbi%7Bpadding-inline-start%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3izwfg%7Bheight%3A2pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsbzwfg%7Bwidth%3A2pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._vchh1ntv%7Bbox-sizing%3Acontent-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i1tcg%7Bheight%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1tcg%7Bwidth%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1o9zidpf%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._nd5l17zh%7Bgrid-area%3Aelem-before%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk1o0g%7Bbackground-color%3Avar(--notch-color)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._t9ec1i34%7Btransform%3AtranslateY(-50%25)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i1crf%7Bheight%3A9pt%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsbyh40%7Bwidth%3A2px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._152t1ssb%7Binset-block-start%3A50%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._14iu1j28%3Aactive%3Anot(%3Adisabled)%7Bbackground-color%3Atransparent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._14iunozp%3Aactive%3Anot(%3Adisabled)%7Bbackground-color%3Avar(--ds-background-selected-pressed%2C%238fb8f6)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._y4tize3t%7Bpadding-inline-end%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bozgze3t%7Bpadding-inline-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._85i5ze3t%7Bpadding-block-end%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1q51ze3t%7Bpadding-block-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._14iu13ro%3Aactive%3Anot(%3Adisabled)%7Bbackground-color%3Avar(--ds-surface-pressed%2C%23dddee1)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._y3gnv2br%7Btext-align%3Astart%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk1j28%7Bbackground-color%3Atransparent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._85i51b66%7Bpadding-block-end%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1q511b66%7Bpadding-block-start%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2z05nbh3%7Bgrid-template-rows%3Asubgrid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._yv0enbh3%7Bgrid-template-columns%3Asubgrid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ii7kb7n%7Bgrid-row%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._yyhyjvu9%7Bgrid-column%3A1%2F-1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kqswh2mm%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i1wto%7Bheight%3A3rem%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._irr3n7od%3Ahover%7Bbackground-color%3Aunset%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syaz1gmx%7Bcolor%3Avar(--ds-text-disabled%2C%23080f214a)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._irr3ufnl%3Ahover%7Bbackground-color%3Avar(--ds-background-selected-hovered%2C%23cfe1fd)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._30l36x5g%3Ahover%7Bcolor%3Avar(--ds-text-selected%2C%231868db)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1swvufnl%3Ahas(%5Baria-expanded%3Dtrue%5D%5Baria-haspopup%3Dtrue%5D)%7Bbackground-color%3Avar(--ds-background-selected-hovered%2C%23cfe1fd)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1yyujmqp%7B--notch-color%3Avar(--ds-background-selected-bold%2C%231868db)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syaz6x5g%7Bcolor%3Avar(--ds-text-selected%2C%231868db)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk15s3%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mfcglyw%3Afocus-within%2C%20._1sjuglyw%3Ahover%7B--elem-after-display%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1djyglyw%3Ahas(%5Baria-expanded%3Dtrue%5D%5Baria-haspopup%3Dtrue%5D)%7B--elem-after-display%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ek6g1txw%7B--actions-on-hover-display%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._91juglyw%7B--elem-after-display%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._85i512x7%7Bpadding-block-end%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1q5112x7%7Bpadding-block-start%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1tkeqf5o%7Bmin-height%3A3.25rem%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._y4tipxbi%7Bpadding-inline-end%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._85i5utpp%7Bpadding-block-end%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1q51utpp%7Bpadding-block-start%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1tke1b9w%7Bmin-height%3A3.75rem%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1brr1txw%3Afocus-within%2C%20._109x1txw%3Ahover%7B--actions-on-hover-display%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._irr31dpa%3Ahover%7Bbackground-color%3Avar(--ds-background-neutral-subtle-hovered%2C%230515240f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ojv1txw%3Ahas(%5Baria-expanded%3Dtrue%5D%5Baria-haspopup%3Dtrue%5D)%7B--actions-on-hover-display%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1swv1dpa%3Ahas(%5Baria-expanded%3Dtrue%5D%5Baria-haspopup%3Dtrue%5D)%7Bbackground-color%3Avar(--ds-background-neutral-subtle-hovered%2C%230515240f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._91ju1txw%7B--elem-after-display%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1yyu1j28%7B--notch-color%3Atransparent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ek6gglyw%7B--actions-on-hover-display%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syazazsu%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._uiztglyw%7B-webkit-user-select%3Anone%3B-moz-user-select%3Anone%3Buser-select%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvr1h6o%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3iviql%7Bheight%3A2rem%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ul9t9kd%7Bmin-width%3A72px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1lmcu4vt%7Bgrid-template-areas%3A%22elem-before%20interactive%20elem-after%20actions%22%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2z05hkll%7Bgrid-template-rows%3A1fr%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._yv0e7dup%7Bgrid-template-columns%3Aminmax(0%2Cauto)%201fr%20minmax(0%2Cauto)%20minmax(0%2Cauto)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c11p5%7Bdisplay%3Agrid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko1qi0%7Bborder-radius%3Avar(--ds-radius-medium%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._12s918uv%3Afocus-within%7Boverflow-y%3Ainitial%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1guo18uv%3Afocus-within%7Boverflow-x%3Ainitial%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ul91c9m%7Bmin-width%3A1ch%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bozg1b66%7Bpadding-inline-start%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._y4ti1b66%7Bpadding-inline-end%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18m915vq%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1reo15vq%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._zulpv77o%7Bgap%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kqswstnw%7Bposition%3Aabsolute%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1r04ze3t%7Binset%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ul9idpf%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ae4v1h6o%7Balign-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._nd5l19l3%7Bgrid-area%3Ainteractive%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._slp31hna%7Bword-wrap%3Abreak-word%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1i4q1hna%7Boverflow-wrap%3Abreak-word%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e02ze3t%7Binset-inline-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._152tze3t%7Binset-block-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syaz15cr%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk1aqn%7Bbackground-color%3Avar(--ds-background-neutral-bold%2C%23292a2e)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bozg12x7%7Bpadding-inline-start%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._85i5v77o%7Bpadding-block-end%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._y4ti12x7%7Bpadding-inline-end%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1q51v77o%7Bpadding-block-start%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._vchhusvi%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._p12f1pna%7Bmax-width%3A420px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1tkezwfg%7Bmin-height%3A2pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bah1h6o%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2lx21bp4%7Bflex-direction%3Acolumn%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._11c8wadc%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko12b0%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
import React, { forwardRef, useCallback, useRef } from 'react';
import { cx } from '@compiled/react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { Anchor, Pressable, Text, type TextColor } from '@atlaskit/primitives/compiled';
import Tooltip, { TooltipPrimitive, type TooltipPrimitiveProps, type TooltipProps } from '@atlaskit/tooltip';
import { COLLAPSE_ELEM_BEFORE, expandableMenuItemIndentation } from '../../constants';
import { forwardRefWithGeneric } from '../../utils/forward-ref-with-generic';
import mergeRefs from '../../utils/merge-refs';
import type { MenuItemCommonProps, MenuItemLinkOrButtonCommonProps, MenuItemOnClick, MenuItemSlots } from './types';
const tooltipStyles = {
  root: "_2rko12b0 _11c8wadc _1e0c1txw _2lx21bp4 _1bah1h6o _1tkezwfg _p12f1pna _vchhusvi _1q51v77o _y4ti12x7 _85i5v77o _bozg12x7 _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _slp31hna"
};
const MenuItemTooltip = forwardRef<HTMLDivElement, TooltipPrimitiveProps>(function MenuItemTooltip({
  children,
  className,
  ...rest
}, ref) {
  return <TooltipPrimitive {...rest}
  // Manually passing on `className` so it gets merged correctly in the build output.
  // The passed classname is mostly used for integration testing (`.Tooltip`)
  // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
  className={ax([tooltipStyles.root, className])}
  // "css" does not "exist" - it gets transformed into "className" by compiled
  ref={ref}>
			{children}
		</TooltipPrimitive>;
});
function isTextClamped(element: HTMLElement): boolean {
  // Checking for vertical height rather than horizontal height.
  // When text is "clamped", it's technically being clamped vertically! 🤯
  return element.scrollHeight > element.clientHeight;
}
const elemAfterDisplayVar = '--elem-after-display';
const actionsOnHoverDisplayVar = '--actions-on-hover-display';
const notchColorVar = '--notch-color';

/**
 * ## 🤹 `position:relative`
 *
 * We need `position:relative` on an element that takes
 * up the full size of the interactive element so we
 * can correctly use `position:absolute` to place:
 * 1. the notch for links
 * 2. drop indicators for drag and drop
 * 3. a child of button / anchor to stretch it out to
 *    increase it's pressable area.
 *
 * ⛔️ We cannot add `position:relative` _only_ on the
 * button / anchor as that will cause sibling elements
 * to be rendered under the button / anchor when setting
 * a background color on the button / anchor.
 *
 * 📖 Note: `position:relative` elements are painted after
 * elements with `position:static` (the default)
 * https://drafts.csswg.org/css-position-4/#painting-order
 *
 * ⛔️ We cannot add `position:relative` to the container
 * element, as then the `:focus` ring styles on the
 * button / anchor can be cut off by the next sibling if it has
 * has a background color set (eg when selected)
 *
 * ✅ Add `position:relative` to all first level descendants
 * of the container element so that we don't impact DOM ordered
 * paint ordering within the item and the button / anchor focus
 * ring can still bleed over siblings
 *
 * 📖 We could use `> * { position: relative; }` on the container,
 * but that would violate our styling standard.
 */
const topLevelSiblingStyles = {
  root: "_kqswh2mm"
};

/**
 * All slots on the menu item (eg `elemBefore`) are rendered as siblings
 * of our main button / anchor element and they are visually placed on
 * top of the main button / anchor.
 *
 * 📖 This is done so that we don't nest interactive elements in our markup.
 *
 * ✅ This is great when element in the slot is an interactive element
 * as we don't want the main menu item button / anchor to be triggered
 * when interacting with the element in the slot.
 *
 * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
 * prevent the main button / anchor (that is visually behind the element in
 * the slot) from being clicked. The element in the slot is a sibling of our
 * main button / anchor (not a child of it) so clicking on the element in the
 * slot will not bubble up to the button / anchor.
 *
 * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
 * element so that static content in a slot does not prevent clicking on the main
 * button / anchor.
 */
const onTopOfButtonOrAnchorStyles = {
  root: "_18ukglyw"
};

/**
 * This is being _internally_ exported so it can be used in other menu item wrapper components, like
 * ExpandableMenuItemTrigger.
 *
 * This selector is used to apply hover styling on the menu item if it contains an open nested popup.
 * It's looking for a popup trigger with `aria-hasexpanded` and `aria-haspopup` attributes. The
 * reason for targeting the _trigger_ instead of the popup itself, is the popup might be rendered
 * outside the menu item, e.g. if rendered in a portal.
 *
 * An alternative solution might involve wrapping it with a popup context and listening to the popup
 * events through it (and applying the hover style when the popup is open). Exploring this has been
 * captured in [BLU-3354](https://jplat.atlassian.net/browse/BLU-3354).
 */
export const nestedOpenPopupCSSSelector = '&:has([aria-expanded="true"][aria-haspopup="true"])';
const containerStyles = {
  root: "_2rko1qi0 _vchhusvi _1e0c11p5 _yv0e7dup _2z05hkll _1lmcu4vt _1ul9t9kd _4t3iviql _4cvr1h6o _uiztglyw _syazazsu _ek6gglyw _1yyu1j28 _91ju1txw _1swv1dpa _1ojv1txw _irr31dpa _1brr1txw _109x1txw",
  large: "_vchhusvi _1tke1b9w _1q51utpp _85i5utpp _y4tipxbi",
  small: "_vchhusvi _1tkeqf5o _1q5112x7 _85i512x7 _y4ti12x7",
  removeElemAfter: "_91juglyw",
  showHoverActions: "_ek6g1txw",
  removeElemAfterOnHoverOrOpenNestedPopup: "_1djyglyw _1mfcglyw _1sjuglyw",
  selected: "_bfhk15s3 _syaz6x5g _1yyujmqp _1swvufnl _30l36x5g _irr3ufnl",
  suppressNotch: "_1yyu1j28 _bozg12x7",
  disabled: "_syaz1gmx _irr3n7od",
  hasDescription: "_4t3i1wto"
};
const buttonOrAnchorStyles = {
  root: "_2rko12b0 _yyhyjvu9 _1ii7kb7n _1e0c11p5 _yv0enbh3 _2z05nbh3 _y4ti1b66 _bozg1b66 _1q511b66 _85i51b66 _bfhk1j28 _syazazsu _4cvr1h6o _y3gnv2br _14iu13ro",
  large: "_1q51ze3t _85i5ze3t _bozgze3t _y4tize3t",
  small: "_1q51ze3t _85i5ze3t _bozgze3t _y4tize3t",
  selected: "_syaz6x5g _14iunozp",
  noActiveBackground: "_14iu1j28"
};
const extendButtonOrAnchorStyles = {
  root: "_1r04ze3t _kqswstnw"
};
const notchStyles = {
  root: "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
};
const actionStyles = {
  root: "_zulp1b66 _nd5lbc26 _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const actionsOnHoverStyles = {
  root: "_nd5l16dh _zulp1b66 _1reo15vq _18m915vq _1e0c1c3z _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const textStyles = {
  root: "_zulpv77o _1reo15vq _18m915vq _y4ti1b66 _bozg1b66 _1e0c1txw _2lx21bp4 _1ul91c9m _1guo18uv _12s918uv",
  noElemBeforeIndent: "_bozg12x7"
};
const elemBeforeStyles = {
  root: "_nd5l17zh _1reo15vq _18m915vq _1e0c1txw _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _bozg1b66 _vchh1ntv _1guo18uv _12s918uv",
  large: "_1bsbzwfg _4t3izwfg _bozgpxbi _12l2utpp"
};
const elemAfterStyles = {
  root: "_nd5l16dh _1reo15vq _18m915vq _1e0c13yo _1o9zidpf _4t3i1tcg _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv",
  large: "_1wpzv2br",
  small: "_1wpz1h6o"
};

/**
 * We are using a wrapping element for our interactive content
 * even though only the `Text` element is the only thing not using `position:absolute`
 *
 * Rationale:
 * - Super clear that everything inside the interactive content should be in a specific slot in the grid
 * - To work around a browser bug in Safari where it does not work well with `position:absolute`
 *   on a subgrid child.
 *   Safari bug: https://bugs.webkit.org/show_bug.cgi?id=292516
 */
const interactiveContentStyles = {
  root: "_nd5l19l3 _1e0c1txw _2lx21bp4 _ae4v1h6o _1ul9idpf"
};
function getTextColor({
  isDisabled,
  isSelected,
  isNewDesignEnabled
}: {
  isDisabled?: boolean;
  isSelected?: boolean;
  isNewDesignEnabled?: boolean;
}): TextColor {
  if (isDisabled) {
    return 'color.text.disabled';
  }
  if (isSelected && !isNewDesignEnabled) {
    return 'color.text.selected';
  }
  if (isNewDesignEnabled) {
    return 'color.text';
  }
  return 'color.text.subtle';
}

/**
 * Includes all props that are used by any menu item, as MenuItembase is the base component for all menu item components.
 *
 * We also include additional `aria` props to support the menu item being a trigger for the FlyoutMenuItem popup and for the
 * expanded content for ExpandableMenuItem.
 */
type MenuItemBaseProps<T extends HTMLAnchorElement | HTMLButtonElement> = MenuItemLinkOrButtonCommonProps & {
  /**
   * ID attribute, passed to the interactive element (anchor/button). This is not publicly exposed, and is currently only
   * used internally by `ExpandableMenuItemTrigger` for the `aria-labelledby` attribute.
   */
  id?: string;
  href?: string | Record<string, any>;
  target?: HTMLAnchorElement['target'];
  isDisabled?: boolean;
  isSelected?: boolean;
  // eslint-disable-next-line @repo/internal/react/consistent-props-definitions
  ariaControls?: string;
  // eslint-disable-next-line @repo/internal/react/boolean-prop-naming-convention, @repo/internal/react/consistent-props-definitions
  ariaExpanded?: boolean;
  // eslint-disable-next-line @repo/internal/react/consistent-props-definitions
  ariaHasPopup?: boolean | 'dialog';
  onClick?: MenuItemOnClick<T>;
  /**
   * Size variant for the menu item.
   * - 'default': 2rem (32px) height
   * - 'small': 3.4 (54px) height with custom padding
   * - 'large': 3.75rem (60px) minimum height with custom padding
   */
  size?: 'default' | 'small' | 'large';
  /**
   * When true, disables the inner :active background on the anchor/button.
   * Useful when the container already provides its own pressed/selected highlight.
   */
  noActiveBackground?: boolean;
  /**
   * When true, applies new design styles: `color.text` for title and increased padding (6px).
   */
  isNewDesignEnabled?: boolean;
};

/**
 * This is the internal version of the component, to be passed into `forwardRef`.
 *
 * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
 * This can be inferred from the type of the `onClick` prop.
 */
const MenuItemBaseNoRef = <T extends HTMLAnchorElement | HTMLButtonElement,>({
  id,
  testId,
  actions,
  actionsOnHover,
  children,
  description,
  elemAfter,
  elemBefore,
  href,
  target,
  isDisabled,
  isSelected,
  onClick,
  ariaControls,
  ariaExpanded,
  ariaHasPopup,
  interactionName,
  isContentTooltipDisabled,
  visualContentRef,
  level = 0,
  size = 'default',
  noActiveBackground,
  isNewDesignEnabled
}: MenuItemBaseProps<T>, forwardedRef: React.ForwardedRef<T>) => {
  const isLink = typeof href !== 'undefined';
  const labelRef = useRef<T | null>(null);
  const descriptionRef = useRef<T | null>(null);
  const tooltipOnClick = useRef<React.MouseEventHandler<HTMLElement> | null>(null);
  const handleClick = useCallback((event: React.MouseEvent<T>, analyticsEvent: UIAnalyticsEvent) => {
    onClick?.(event, analyticsEvent);
    tooltipOnClick.current?.(event);
  }, [onClick]);

  /**
   * Show the tooltip if _either_ label or description is truncated
   */
  const canTooltipAppear = useCallback((): boolean => {
    if (isContentTooltipDisabled) {
      return false;
    }

    // Show tooltip if _either_ label or description are clamped

    const label = labelRef.current;
    const description = descriptionRef.current;
    if (label && isTextClamped(label)) {
      return true;
    }
    return Boolean(description && isTextClamped(description));
  }, [isContentTooltipDisabled]);

  // By default provide the spacing for `elemBefore` to have good
  // vertical alignment of labels and to give clear indentation between levels
  // in the side navigation (even when items don't use elemBefore).
  const showElemBefore = elemBefore !== COLLAPSE_ELEM_BEFORE;
  const interactiveElemContent = <div className={ax([interactiveContentStyles.root])}>
			{/**
    * We are creating a hidden element to increase the interactive area of our menu items.
    * This enables users to only need to move their pointers vertically to be able to access
    * nested menu items.
    *
    * 📺 More context: https://www.youtube.com/watch?v=zVFJAwrCQCM
    *
    * Notes:
    *
    * - We cannot use `::before` on the interactive element itself as you
    *   cannot drag a `button` element from `::before` in Firefox
    *   https://bugzilla.mozilla.org/show_bug.cgi?id=1967645
    * - The hidden element uses `position:absolute` so it won't impact layout
    *
    */}
			<div
    // This extends the clickable area of nested menu items to the width
    // of the root level menu items, while being visually indented.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    style={{
      insetInlineStart: `calc(-1 * ${level} * ${expandableMenuItemIndentation})`
    }} aria-hidden="true" className={ax([extendButtonOrAnchorStyles.root])} />
			<div className={ax([textStyles.root, !showElemBefore && textStyles.noElemBeforeIndent])}>
				<Text weight="medium" maxLines={1} color={getTextColor({
        isDisabled,
        isSelected,
        isNewDesignEnabled
      })} ref={labelRef}>
					{children}
				</Text>
				{description && <Text color={isDisabled ? 'color.text.disabled' : 'color.text.subtle'} size="small" maxLines={1} ref={descriptionRef}>
						{description}
					</Text>}
			</div>
		</div>;

  /**
   *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
   *
   * Note: we also remove the `elemAfter` when showing `actionsOnHover`
   */
  const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
  const isLarge = size === 'large';
  const isSmall = size === 'small';
  return <div ref={visualContentRef} data-testid={testId ? `${testId}-container` : undefined} data-selected={isSelected} className={ax([containerStyles.root, isLarge && containerStyles.large, isSmall && containerStyles.small, isSelected && containerStyles.selected, isNewDesignEnabled && containerStyles.suppressNotch, description && !isLarge && containerStyles.hasDescription, showHoverActionsWhenNotHovered && containerStyles.showHoverActions, showHoverActionsWhenNotHovered && elemAfter && containerStyles.removeElemAfter, actionsOnHover && elemAfter && containerStyles.removeElemAfterOnHoverOrOpenNestedPopup, isDisabled && containerStyles.disabled])}>
			<Tooltip content={() => <>
						<div>{children}</div>
						{description ? <div>{description}</div> : null}
					</>} position="right"
    // NOTE: Types in React 18 have changed and `forwardRef(() => <TooltipPrimitive>)` no longer appears to match 100%
    component={(MenuItemTooltip as TooltipProps['component'])} ignoreTooltipPointerEvents hideTooltipOnMouseDown
    // We don't need a duplicate hidden element containing tooltip content
    // as the content of the tooltip matches what is rendered for the menu item.
    isScreenReaderAnnouncementDisabled canAppear={canTooltipAppear}>
				{tooltipProps => {
        // Putting the tooltip onClick into a ref.
        // This way we don't need to create a new `onClick` function on each
        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
        tooltipOnClick.current = tooltipProps.onClick;
        const sharedProps = {
          ...tooltipProps,
          'aria-controls': ariaControls,
          'aria-haspopup': ariaHasPopup,
          ref: mergeRefs([forwardedRef, tooltipProps.ref]),
          id,
          testId,
          interactionName
        };
        return isLink ? <Anchor {...sharedProps} onClick={(handleClick as MenuItemOnClick<HTMLAnchorElement>)} xcss={cx(buttonOrAnchorStyles.root, isLarge && buttonOrAnchorStyles.large, isSmall && buttonOrAnchorStyles.small, topLevelSiblingStyles.root, isSelected && buttonOrAnchorStyles.selected, noActiveBackground && buttonOrAnchorStyles.noActiveBackground)}
        // Needed to override Anchor style due to a compiled/emotion conflict
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style={{
          textDecoration: 'none'
        }} aria-current={isSelected ? 'page' : undefined} href={href} target={target}
        /**
         * rovo-navigation
         * Disable drag and drop for simpler implementation
         */ draggable={false}>
							{/* Won't be a "grid child" */}
							<div aria-hidden="true" className={ax([notchStyles.root])} />
							{interactiveElemContent}
						</Anchor> : <Pressable {...sharedProps} onClick={(handleClick as MenuItemOnClick<HTMLButtonElement>)} xcss={cx(buttonOrAnchorStyles.root, isLarge && buttonOrAnchorStyles.large, isSmall && buttonOrAnchorStyles.small, topLevelSiblingStyles.root, isSelected && buttonOrAnchorStyles.selected, noActiveBackground && buttonOrAnchorStyles.noActiveBackground)} aria-expanded={ariaExpanded} isDisabled={isDisabled}>
							{interactiveElemContent}
						</Pressable>;
      }}
			</Tooltip>
			{showElemBefore && <div className={ax([elemBeforeStyles.root, isLarge && elemBeforeStyles.large, topLevelSiblingStyles.root, onTopOfButtonOrAnchorStyles.root])}>
					{(elemBefore as React.ReactNode)}
				</div>}
			{actionsOnHover && <div className={ax([actionsOnHoverStyles.root])}>{actionsOnHover}</div>}
			{elemAfter && <div className={ax([elemAfterStyles.root, size === 'large' && elemAfterStyles.large, size === 'small' && elemAfterStyles.small, topLevelSiblingStyles.root, onTopOfButtonOrAnchorStyles.root])}>
					{elemAfter}
				</div>}
			{actions && <div className={ax([actionStyles.root, topLevelSiblingStyles.root, onTopOfButtonOrAnchorStyles.root])}>
					{actions}
				</div>}
		</div>;
};

/**
 * __MenuItemBase__
 *
 * The base menu item component used to compose ButtonMenuItem and LinkMenuItem.
 *
 * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
 * This can be inferred from the type of the `onClick` prop.
 */
export const MenuItemBase: <T extends HTMLAnchorElement | HTMLButtonElement>(props: MenuItemCommonProps & MenuItemSlots & {
  description?: React.ReactNode;
  listItemRef?: React.Ref<HTMLDivElement>;
} & {
  /**
   * ID attribute, passed to the interactive element (anchor/button). This is not publicly exposed, and is currently only
   * used internally by `ExpandableMenuItemTrigger` for the `aria-labelledby` attribute.
   */
  id?: string;
  href?: string | Record<string, any>;
  target?: HTMLAnchorElement['target'];
  isDisabled?: boolean;
  isSelected?: boolean;
  // eslint-disable-next-line @repo/internal/react/consistent-props-definitions
  ariaControls?: string;
  // eslint-disable-next-line @repo/internal/react/boolean-prop-naming-convention, @repo/internal/react/consistent-props-definitions
  ariaExpanded?: boolean;
  // eslint-disable-next-line @repo/internal/react/consistent-props-definitions
  ariaHasPopup?: boolean | 'dialog';
  onClick?: MenuItemOnClick<T> | undefined;
  /**
   * Size variant for the menu item.
   * - 'default': 2rem (32px) height
   * - 'small': 3.25rem (52px) minimum height with custom padding
   * - 'large': 3.75rem (60px) minimum height with custom padding
   */
  size?: 'default' | 'small' | 'large';
  /**
   * When true, disables the inner :active background on the anchor/button.
   * Useful when the container already provides its own pressed/selected highlight.
   */
  noActiveBackground?: boolean;
  /**
   * When true, applies new design styles: `color.text` for title and increased padding (6px).
   */
  isNewDesignEnabled?: boolean;
} & React.RefAttributes<T>) => React.ReactElement | null = forwardRefWithGeneric(MenuItemBaseNoRef);